import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../services/api';
import './StocktakeForm.css';

const StocktakeForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    stocktakeName: '',
    description: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.stocktakeName.trim()) {
      setError('Stocktake name is required');
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      const response = await apiClient.post('/stocktake/start', formData);
      
      // Navigate to the stocktake conduct page
      navigate(`/inventory/stocktakes/${response.data.stocktakeId}/conduct`);
    } catch (error) {
      console.error('Error starting stocktake:', error);
      setError(error.response?.data?.message || 'Failed to start stocktake');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/inventory/stocktakes');
  };

  return (
    <div className="stocktake-form">
      <div className="form-header">
        <h1>Start New Stocktake</h1>
        <p className="form-description">
          Create a new stocktake session to count and verify your inventory items.
        </p>
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="stocktake-form-container">
        <div className="form-group">
          <label htmlFor="stocktakeName" className="form-label">
            Stocktake Name *
          </label>
          <input
            type="text"
            id="stocktakeName"
            name="stocktakeName"
            value={formData.stocktakeName}
            onChange={handleChange}
            className="form-input"
            placeholder="Enter stocktake name (e.g., Monthly Stocktake - January 2024)"
            required
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="description" className="form-label">
            Description
          </label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="form-textarea"
            placeholder="Optional description for this stocktake session"
            rows={4}
            disabled={loading}
          />
        </div>

        <div className="info-box">
          <div className="info-icon">ℹ️</div>
          <div className="info-content">
            <h4>What happens next?</h4>
            <ul>
              <li>A stocktake session will be created with all current inventory items</li>
              <li>You'll be taken to the counting interface to record actual quantities</li>
              <li>System quantities will be compared with your counts</li>
              <li>Variances can be reviewed and inventory adjusted accordingly</li>
            </ul>
          </div>
        </div>

        <div className="form-actions">
          <button
            type="button"
            onClick={handleCancel}
            className="btn btn-secondary"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Starting...' : 'Start Stocktake'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default StocktakeForm;